import { memo } from 'react';
import { Box, Typography } from '@mui/material';
import InfoItem from '@/components/common/InfoItem';
import ProgressBar from '@/components/common/ProgressBar';
import { formatDecimalToPercentage } from '@/utils/formatting';

interface SpeechProportionInfoItemProps {
    label: string;
    labelId: string;
    proportion: number;
}

/**
 * Displays the talk time distribution between agent and customer.
 *
 * @param {SpeechProportionInfoItemProps} props
 * @returns {JSX.Element}
 */
const SpeechProportionInfoItem: React.FC<SpeechProportionInfoItemProps> = ({ label, labelId, proportion }) => (
    <InfoItem label={label} labelId={labelId} variant="filled" direction="vertical" status="default">
        <ProgressBar value={proportion * 100} height={12} />
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: 0.5,
                justifyContent: 'space-between',
                alignItems: 'center',
                mt: 0.5,
            }}
        >
            <Typography variant="body2" sx={{ color: 'devblue.100' }}>
                Agent {formatDecimalToPercentage(proportion)}
            </Typography>
            <Typography variant="body2" sx={{ color: 'devblue.100' }}>
                Customer {formatDecimalToPercentage(1 - proportion)}
            </Typography>
        </Box>
    </InfoItem>
);

export default memo(SpeechProportionInfoItem);
